import { ContentBlock } from '@libs/types/generated/housing-market-ui'
import { FC } from 'react'

type Props = Partial<ContentBlock>

const TextContent: FC<Props> = ({ content = [], anchors = [] }) => {
  return (
    <>
      {content.map((c, i) => {
        let content = c
        anchors.forEach(a => {
          content = content.replace(
            new RegExp(a.match),
            `<a href="${a.url}">${a.match}</a>`
          )
        })

        return <p key={i} dangerouslySetInnerHTML={{ __html: content }}></p>
      })}
    </>
  )
}

export default TextContent
